/**
 * Umami Custom Events — zentraler, typisierter Wrapper.
 *
 * Umami ist das primäre Auswertungstool: Pageviews trackt das Script automatisch
 * (SPA-Routenwechsel inklusive), alles darüber hinaus läuft über diese Events.
 * Namenskonvention: deutsch, kebab-case, wenige Event-Namen mit Daten-Payload
 * (Umami kann nach Event-Daten aufschlüsseln) statt vieler Einzel-Namen.
 *
 * Event-Katalog:
 *   filter                  – Such-/Filternutzung auf der Event-Liste (nur aktive Filter im Payload)
 *   event-anmeldung         – Klick auf den Anmelde-/Veranstalter-Link (wichtigste Engagement-Metrik)
 *   event-link              – Klick auf sonstige öffentliche Event-Links {typ}
 *   event-ical              – iCal-Download
 *   event-favorit           – Favorit hinzugefügt/entfernt {aktion}
 *   event-vorschlag         – Community-Vorschlag eingereicht {typ: neu|aenderung}
 *   banner-impression       – Werbebanner angezeigt {banner, platzierung}
 *   banner-klick            – Werbebanner geklickt {banner, platzierung}
 *   news-klick              – News-Artikel in einer Liste angeklickt {artikel, platzierung}
 *   newsletter-registrierung– Registrierung über das Digest-Modal {bundesland}
 *   registrierung           – Registrierung über die Register-Seite
 *   partner-anfrage         – Kontaktformular der "Für Partner"-Seite abgeschickt
 *   veranstalter-funnel     – Monetarisierungsweg {schritt, angebot?, veranstalter?, ergebnis?}
 *   karte-geoeffnet         – Umkreis-Karte geöffnet {variante} — Mengengerüst für die Kachellast
 *   karte-kachelfehler      – Kartenkacheln laden nicht (einmal je Kartensitzung)
 *
 * Die beiden Karten-Events sind eine Frühwarnung: wir beziehen die Kacheln von
 * openstreetmap.org, deren Nutzungsrichtlinie starken Verkehr untersagt. `karte-geoeffnet` zeigt,
 * wie viel wir dort abrufen; `karte-kachelfehler` schlägt an, wenn sie uns drosseln — dann bleibt
 * die Karte grau, ohne dass es sonst irgendwo auffiele.
 */

export type UmamiEventData = Record<string, string | number | boolean>;

declare global {
  interface Window {
    umami?: { track: (name: string, data?: UmamiEventData) => void };
  }
}

/** Fire-and-forget: no-op wenn das Umami-Script nicht geladen ist (dev, Adblocker). */
export function umamiTrack(name: string, data?: UmamiEventData): void {
  try {
    window.umami?.track(name, data);
  } catch {
    /* Analytics darf nie die Seite stören */
  }
}
